import { SyncEventType } from '../../enums/syncEventType';
import { RealtimeEvent } from './realtimeEvent';

export class EventSprintcardMoved implements RealtimeEvent {

  public readonly type = SyncEventType.ISSUECARD_MOVED;
  public sprintId: number;
  public position: any;

  constructor(sprintId: number, position: any) {
    this.sprintId = sprintId;
    this.position = position;
  }

  getPayload(): object {
    const payload = {
      'sprintId': this.sprintId,
      'position': this.position
    };
    return payload;
  }

  static fromPayload(payload: any): EventSprintcardMoved {
    return new EventSprintcardMoved(
      payload['sprintId'],
      payload['position']
    );
  }

}

